import React from 'react';
const Example = () => (<div>
        <div className="p-6 mb-4 bg-partial-brand-light text-dark shadow-uniform">.bg-partial-brand-light</div>
        <div className="p-6 mb-4 bg-partial-brand-dark text-dark shadow-uniform">.bg-partial-brand-dark</div>
        <div className="p-6 mb-4 bg-partial-brand-orange text-dark shadow-uniform">.bg-partial-brand-orange</div>
        <div className="p-6 mb-4 bg-partial-primary text-dark shadow-uniform">.bg-partial-primary</div>
        <div className="p-6 mb-4 bg-partial-alternative text-dark shadow-uniform">.bg-partial-alternative</div>
        <div className="p-6 mb-4 bg-partial-secondary text-dark shadow-uniform">.bg-partial-secondary</div>
        <div className="p-6 mb-4 bg-partial-success text-dark shadow-uniform">.bg-partial-success</div>
        <div className="p-6 mb-4 bg-partial-danger text-dark shadow-uniform">.bg-partial-danger</div>
        <div className="p-6 mb-4 bg-partial-warning text-dark shadow-uniform">.bg-partial-warning</div>
        <div className="p-6 mb-4 bg-partial-info text-dark shadow-uniform">.bg-partial-info</div>
        <div className="p-6 mb-4 bg-partial-light text-dark shadow-uniform">.bg-partial-light</div>
        <div className="p-6 mb-4 bg-partial-content text-dark shadow-uniform">.bg-partial-content</div>
        <div className="p-6 mb-4 bg-partial-dark text-dark shadow-uniform">.bg-partial-dark</div>
    </div>);
export default Example;
